// validateEnv.js - Environment variable validation
export function validateEnv() {
  const required = {
    VITE_API_URL: import.meta.env.VITE_API_URL,
    VITE_FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY,
    VITE_FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  };

  const optional = {
    VITE_GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  };

  const missing = Object.entries(required)
    .filter(([_, value]) => !value)
    .map(([key]) => key);

  if (missing.length > 0) {
    console.error('❌ Missing required environment variables:');
    missing.forEach(key => console.error(`   - ${key}`));
    throw new Error('Missing required environment variables');
  }

  // Validate API URL format and port
  const apiUrl = new URL(import.meta.env.VITE_API_URL);
  const backendPort = apiUrl.port;
  
  console.log('✅ Environment validation passed');
  console.log('📝 Configuration:');
  console.log(`   - API URL: ${apiUrl.origin}`);
  console.log(`   - Backend Port: ${backendPort}`);
  console.log(`   - Environment: ${import.meta.env.MODE}`);
  console.log(`   - Google Maps API: ${optional.VITE_GOOGLE_MAPS_API_KEY ? '✅ Configured' : '⚠️  Not configured (address autocomplete disabled)'}`);
}

// Run validation immediately
validateEnv(); 